import { singleValueReducer } from 'store/reducerUtils';
import { SET_SUBMITTING_ORG_FILTER } from 'modules/settings/submodules/clients/submittingOrg/components/Filter/store/actions';

export const submittingOrgFilter = singleValueReducer(SET_SUBMITTING_ORG_FILTER, '');
